import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  helpText: {
    color: 'white',
    fontSize: '2rem',
    marginBottom: theme.spacing(3),
    textTransform: 'uppercase',
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
    '@media (max-width: 1024px)': {
      fontSize: '1.4rem',
      marginBottom: theme.spacing(2)
    }
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/HelpText/styles.js